import script from "./EditActivityGeneralForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditActivityGeneralForm.vue?vue&type=script&setup=true&lang=js"

import "./EditActivityGeneralForm.vue?vue&type=style&index=0&id=4ccc786e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ccc786e"]])

export default __exports__